<template>
    <div class="assignment__item">
        <img :src="getAvatar()" class="assignment__item-image img-thumbnail">
        <div class="assignment__item-info">
            <!-- Dequeue/Requeue -->
            <button v-if="type == 'dequeued'" type="button" class="btn btn-sm btn-light-warning float-right"
                data-toggle="modal" :data-target="'#' + getId">
                <i class="far fa-history"></i> Requeue
            </button>
            <button v-if="type == 'queued'" type="button" class="btn btn-sm btn-light-success float-right"
                data-toggle="modal" :data-target="'#' + getId">
                <i class="far fa-check"></i> Dequeue
            </button>
            <!-- Triage -->
            <button v-if="item.triageData" type="button" class="btn btn-sm btn-light-primary float-right mr-2"
                data-toggle="modal" :data-target="'#' + getViewId" aria-expanded="true" aria-controls="collapse"><i
                    class="fas fa-file-alt"></i> Triage</button>
            <!-- View -->
            <button type="button" class="btn btn-sm btn-light-primary float-right mr-2" data-toggle="collapse"
                :data-target="'#' + getToggleId" aria-expanded="true" aria-controls="collapse"><i
                    class="far fa-user-circle"></i> View</button>
            <!-- Notify -->
            <button v-if="type == 'queued'" type="button" class="btn btn-sm btn-light-success float-right mr-2"
                data-toggle="modal" :data-target="'#' + getNotifyId" aria-expanded="true" aria-controls="collapse"
                @click="getNotificationSetting()"><i class="fas fa-bell"></i> Notify</button>
            <!-- Assign to me -->
            <button v-if="type == 'queued' && item.counsellor == '_general'" type="button"
                class="btn btn-sm btn-light-success float-right mr-2" data-toggle="modal"
                :data-target="'#' + getAssignId" aria-expanded="true" aria-controls="collapse"><i
                    class="fas fa-exchange-alt"></i> Assign To Me</button>
            <span class="assignment__item-name">
                {{ item.name }}
            </span>
            <span class="assignment__item-number">
                ({{ item.number }})
            </span>
            <div class="assignment__item-counsellor">
                <label class="assignment__item-subheader">
                    Counsellor
                </label> {{ getCounsellor }}
            </div>
            <div :id="getToggleId" class="collapse" aria-labelledby="description">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 border-bottom mb-3 pb-3 text-center">
                                <img :src="getAvatar()" class="img__avatar img-fluid img-thumbnail">
                            </div>
                            <hr>
                            <div class="col-md-6">
                                <div class="assignment__item-id">
                                    <label class="assignment__item-subheader">
                                        Student Number
                                    </label> {{ getStudentNumber }}
                                </div>
                                <div class="assignment__item-email">
                                    <label class="assignment__item-subheader">
                                        Western Email
                                    </label> {{ getEmail }}
                                </div>
                                <div class="assignment__item-checkin">
                                    <label class="assignment__item-subheader">
                                        Check-in
                                    </label> {{ getLocalTime }}
                                </div>
                                <div class="assignment__item-appointmenttype">
                                    <label class="assignment__item-subheader">
                                        Apointment Type
                                    </label> {{ getAppointmentType }}
                                </div>
                                <div class="assignment__item-waitingarea">
                                    <label class="assignment__item-subheader">
                                        Waiting Area
                                    </label> {{ getWaitingArea }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="assignment__item-program">
                                    <label class="assignment__item-subheader">
                                        Program
                                    </label>
                                    {{ getProgram }}
                                </div>
                                <div class="assignment__item-description">
                                    <label class="assignment__item-subheader">
                                        Reason for visit/Additional Notes
                                    </label>
                                    {{ getDescription }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Assign to me -->
        <div v-if="type == 'queued' && item.counsellor == '_general'" class="modal fade" :id="getAssignId" tabindex="-1"
            role="dialog" aria-labelledby="itemTriageInformation" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="itemTriageInformation">Assign To Me</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Are you sure you want to <b>assign</b> this <b>student ({{ item.name }})</b> to you? Please
                        click confirm to
                        proceed.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-success" data-dismiss="modal"
                            @click="assignToMe()">Confirm</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Deqeuue/requeue -->
        <div class="modal fade" :id="getId" tabindex="-1" role="dialog" aria-labelledby="item" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div v-if="type == 'queued'" class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="item">Dequeue Item</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <i class="far fa-check-square fa-2x icon__success"></i>
                        <span v-if="item.name">
                            You are about to <b>process</b> the queue item
                            for <b>{{ item.name }}</b>. Please click the <b>confirm</b> button to
                            proceed.
                        </span>
                        <span v-else>
                            You are about to <b>process</b> this queue item. Please click the <b>confirm</b> button to
                            proceed.
                        </span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                            @click="removeQueueItem">Confirm</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
                <div v-else-if="type == 'dequeued'" class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="item">Requeue Item</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <i class="far fa-exclamation-triangle fa-2x icon__warning"></i>
                        <span v-if="item.name">
                            You are about to <b>requeue</b> the item of <b>{{ item.name }}</b>. Please click the
                            <b>confirm</b>
                            button to
                            proceed.
                        </span>
                        <span v-else>
                            You are about to <b>requeue</b> the item. Please click the <b>confirm</b> button to
                            proceed.
                        </span>
                        <form :id="getFormDequeueId">
                            <div class="form-group mt-2 mb-0">
                                <label class="mb-0" for="assignNewNumber">Select a requeue option:</label>
                                <select class="form-control form-control-sm" id="assignNewNumber"
                                    name="assignNewNumber">
                                    <option value="0">Place in queue with original number</option>
                                    <option value="1">Assign a new number and place at the end</option>
                                </select>
                            </div>
                            <div class="form-group mt-2 mb-0">
                                <label class="mb-0" for="counsellor">Assigned Counsellor:</label>
                                <select class="form-control form-control-sm" id="counsellor" name="counsellor"
                                    v-model="item.counsellor">
                                    <option value="">None</option>
                                    <option v-for="counsellor in counsellors" :key="counsellor.username"
                                        :value="counsellor.username"> {{ counsellor.commonName }}</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                            @click="addQueueItem">Confirm</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Notification-->
        <div class="modal fade" :id="getNotifyId" tabindex="-1" role="dialog" aria-labelledby="itemNotifyForm"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="itemNotifyForm">Send Notification</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="notificationStatus == 'sent'" class="alert alert-success" role="alert">
                            <i class="fas fa-check"></i> The notification has been successfully sent!
                        </div>
                        <div v-else-if="notificationStatus == 'warning'" class="alert alert-warning" role="alert">
                            <i class="fas fa-exclamation-circle"></i> A counsellor must be assigned to the queue item in
                            order to send a notification.
                        </div>
                        <div v-else-if="notificationStatus == 'error'" class="alert alert-danger" role="alert">
                            <i class="fas fa-exclamation-triangle"></i> The notification could not be sent. Please
                            contact
                            your system admninistrator.
                        </div>
                        <form :id="getNotifyFormId">
                            <div class="form-group">
                                <label for="notificationType" class="font-weight-bold">Notification Type</label>
                                <select v-model="notification.notificationType"
                                    :class="notificationTypeValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationType" :disabled="notificationStatus == 'loading'"
                                    @change="setNotification()">
                                    <option value="" disabled>Please select...
                                    </option>
                                    <option v-for="(item, i) in notificationTypes" :key="i"
                                        :value="item.notificationType">
                                        {{ item.notificationType }}</option>
                                    <option value="Other">Other</option>
                                </select>
                                <div v-if="!notificationTypeValid" class="invalid-feedback">
                                    Please select a valid notification.
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="notificationSubject" class="font-weight-bold">Notification Subject</label>
                                <div v-if="notification.notificationType == 'Other'" class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><small>King's ADO Digital Check-in:</small></div>
                                    </div>
                                    <input v-model="notification.subject"
                                        :disabled="notification.notificationType != 'Other'"
                                        :class="notificationSubjectValid == true ? 'form-control' : 'form-control is-invalid'"
                                        id="notificationSubject" placeholder="Please provide a notification subject">
                                </div>
                                <input v-else v-model="notification.subject"
                                    :disabled="notification.notificationType != 'Other'"
                                    :class="notificationSubjectValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationSubject" placeholder="Please provide a notification subject">
                                <div v-if="!notificationSubjectValid" class="invalid-feedback">
                                    Please provide a valid notification subject.
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="notificationMessage" class="font-weight-bold">Notification Message</label>
                                <textarea v-model="notification.message"
                                    :disabled="notification.notificationType != 'Other'"
                                    :class="notificationMessageValid == true ? 'form-control' : 'form-control is-invalid'"
                                    id="notificationMessage" rows="10"
                                    placeholder="Please provide a notification message"></textarea>
                                <div v-if="!notificationMessageValid" class="invalid-feedback">
                                    Please provide a valid notification message.
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="notificationStatus == 'submit'" type="button" class="btn btn-sm btn-success"
                            disabled>Sending <i class="fas fa-spinner fa-spin"></i></button>
                        <button v-else-if="notificationStatus == 'sent'" type="button" class="btn btn-sm btn-success"
                            disabled>Sent <i class="fas fa-check"></i></button>
                        <button v-else-if="notificationStatus == 'loading'" type="button" class="btn btn-sm btn-primary"
                            disabled>Loading <i class="fas fa-spinner fa-spin"></i></button>
                        <button v-else-if="notificationStatus == 'warning' || notificationStatus == 'error'"
                            type="button" class="btn btn-sm btn-primary" disabled>Send</button>
                        <button v-else type="button" class="btn btn-sm btn-primary"
                            @click="sendNotification()">Send</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Triage form -->
        <div v-if="item.triageData" class="modal fade" :id="getViewId" tabindex="-1" role="dialog"
            aria-labelledby="itemTriageInformation" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-large" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="itemTriageInformation">Triage Information</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <triage-form-preview :triageData="item.triageData"></triage-form-preview>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TriageFormPreview from '../Triage/TriageForm.vue';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'assignment-item',
    components: {
        TriageFormPreview
    },
    props: {
        counsellors: {
            type: Array,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            notification: {
                message: '',
                notificationType: '',
                subject: ''
            },
            notificationTypes: [{
                message: `Your Academic Counselling appointment with [Academic Team Member Name] will begin in approximately 10 minutes. Please come to the [waiting area location] waiting area of Dante Lenardon Hall. Only 3 persons max can be in the waiting area, should there be more than 3 persons there when you arrive please wait outside.\r\nThank you.`,
                subject: 'Appointment Notification',
                type: 'Appointment Notification - 10 Minutes'
            }],
            notificationMessageValid: true,
            notificationStatus: '',
            notificationSubjectValid: true,
            notificationTypeValid: true,
            updateItemStatus: false,
        }
    },
    methods: {
        addQueueItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formRef = document.getElementById(`requeue${this.item.itemid}`);
            const formData = new FormData(formRef);

            // Add form keypair values
            formData.append('id', this.item.itemid);
            formData.append('mode', 'requeueItem');
            formData.append('department', DEPARTMENT);
            formData.append('queueType', 'queued');
            formData.append('queueReason', 'Requeued');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                if (json.result.match(/^OK/i)) {
                    that.$emit('setAlert', `The assignment for ${that.item.name} has been requeued.`, 'success');
                } else {
                    that.$emit('setAlert', `The assignment for ${that.item.name} could not be requeued. Please contact your system administrator.`, 'warning');
                }
                that.$emit('refreshAssignments');
            }).catch(function () {
                that.$emit('setAlert', `An internal error has occurred. Please contact your system administrator.`, 'danger');
                that.$emit('refreshAssignments');
            })
        },
        assignToMe() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formData = new FormData();

            // Add form keypair values
            formData.append('department', DEPARTMENT);
            formData.append('id', this.item.itemid);
            formData.append('mode', 'assignToMe');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                if (json.result.match(/^OK/i)) {
                    that.$emit('setAlert', `The student ${that.item.name} has now been assigned to you.`, 'success');
                } else {
                    that.$emit('setAlert', `The student ${that.item.name} could not be assigned to you. Please contact your system administrator.`, 'warning');
                }
                that.$emit('refreshAssignments');
            }).catch(function () {
                that.$emit('setAlert', `An internal error has occurred. Please contact your system administrator.`, 'danger');
                that.$emit('refreshAssignments');
            })
        },
        getAvatar() {
            if (this.item && this.item.photo) {
                return `data:image/jpeg;base64,` + btoa(`${this.item.photo}`);
            }

            return `../src/assets/avatar/profile.jpg`;
        },
        getNotificationSetting() {
            const that = this;
            let api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getNotificationTypes&department=${DEPARTMENT}&id=${this.item.itemid}`;

            // Reset settings
            this.resetNotification();

            // Set loader
            this.notificationStatus = 'loading';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.notificationTypes = json.data || that.notificationTypes;
                        // Set loader       
                        that.notificationStatus = '';
                    } else if (json.result.match(/^WARNING/i)) {
                        that.notificationStatus = 'warning';
                    } else {
                        that.notificationStatus = 'error';
                    }
                })
                .catch(function (error) {
                    // Set loader
                    that.notificationStatus = 'error';
                });
        },
        removeQueueItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formData = new FormData();

            // Add form keypair values
            formData.append('id', this.item.itemid);
            formData.append('mode', 'dequeueItem');
            formData.append('counsellor', this.item.counsellor);
            formData.append('department', DEPARTMENT);
            formData.append('queueType', 'dequeued');
            formData.append('queueReason', 'Completed');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                if (json.result.match(/^OK/i)) {
                    that.$emit('setAlert', `The assignment for ${that.item.name} has been dequeued.`, 'success');
                } else {
                    that.$emit('setAlert', `The assignment for ${that.item.name} could not be dequeued. Please contact your system administrator.`, 'warning');
                }
                that.$emit('refreshAssignments');
            }).catch(function () {
                that.$emit('setAlert', `An internal error has occurred. Please contact your system administrator.`, 'danger');
                that.$emit('refreshAssignments');
            })
        },
        resetNotification() {
            // Reset notification
            this.notification = {
                message: '',
                notificationType: '',
                type: ''
            };
            this.notificationMessageValid = true;
            this.notificationSubjectValid = true;
            this.notificationStatus = '';
            this.notificationTypeValid = true;
        },
        sendNotification() {
            if (this.validateNotification()) {
                const that = this;
                const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?sendNotification`;
                const formData = new FormData();

                // Add form keypair values
                formData.append('department', DEPARTMENT);
                formData.append('id', this.item.itemid);
                formData.append('message', this.notification.message);
                formData.append('mode', 'sendNotification');
                formData.append('notificationType', this.notification.notificationType);
                formData.append('subject', this.notification.notificationType == "Other" ? `King's ADO Digital Check-in: ${this.notification.subject}` : this.notification.subject);

                // Submit status
                this.notificationStatus = 'submit';

                // POST request
                fetch(api, {
                    method: 'POST',
                    body: formData
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    // Success
                    if (json.result.match(/^OK/i)) {
                        that.notificationStatus = 'sent';
                    } else {
                        that.notificationStatus = 'error';
                    }
                }).catch(function () {
                    that.notificationStatus = 'error';
                })
            }
        },
        setNotification() {
            // Check for other
            if (this.notification.notificationType == "Other") {
                this.notification.message = '';
                this.notification.subject = '';
            } else {
                for (let i = 0; i < this.notificationTypes.length; i++) {
                    if (this.notificationTypes[i].notificationType == this.notification.notificationType) {
                        this.notification.message = this.notificationTypes[i].message;
                        this.notification.subject = this.notificationTypes[i].subject;
                        break;
                    }
                }
            }
        },
        validateNotification() {
            let valid = true

            // Validate notification form
            this.notificationMessageValid = this.notification.message && this.notification.message.length >= 2 ? true : false;
            this.notificationSubjectValid = this.notification.subject && this.notification.subject.length >= 2 ? true : false;
            this.notificationTypeValid = this.notification.notificationType && this.notification.notificationType != "" ? true : false;

            // Validate form
            if (!this.notificationMessageValid || !this.notificationSubjectValid || !this.notificationTypeValid) {
                valid = false;
            } else {
                valid = true;
            }

            return valid;
        }
    },
    computed: {
        getAppointmentType() {
            return this.item.appointmentType || 'Not specified';
        },
        getAssignId() {
            return `assign${this.item.itemid}`;
        },
        getCounsellor() {
            const assignedCounsellor = this.item.counsellor;
            let counsellor;

            // Find counsellor
            if (assignedCounsellor) {
                counsellor = this.counsellors.find(function (counsellor) {
                    return counsellor.username.match(assignedCounsellor);
                });

                if (counsellor && counsellor.commonName) {
                    return counsellor.commonName;
                }
            }

            return 'Not assigned';
        },
        getDescription() {
            return this.item.notes || 'No description';
        },
        getEmail() {
            return this.item.emailid || 'Not specified';
        },
        getFormDequeueId() {
            return `requeue${this.item.itemid}`;
        },
        getId() {
            return `queue${this.item.itemid}`;
        },
        getLocalTime() {
            let timestamp = this.item.timestampCheckin * 1000;
            let date = new Date(timestamp);

            // Return local date/time
            return date.toLocaleString();
        },
        getNotifyId() {
            return `notify${this.item.itemid}`;
        },
        getNotifyFormId() {
            return `notifyForm${this.item.itemid}`;
        },
        getProgram() {
            return this.item.program || 'Not specified';
        },
        getStudentNumber() {
            return this.item.emplid || 'Not specified';
        },
        getToggleId() {
            return `toggle${this.item.itemid}`;
        },
        getViewId() {
            return `view${this.item.itemid}`;
        },
        getWaitingArea() {
            return this.item.waitingArea || 'Not assigned';
        }
    }
}
</script>

<style scoped>
.assignment__item-alert {
    color: #ffb822;
    float: right;
    font-weight: 600;
}

.assignment__item-appointmenttype {
    margin-bottom: .5rem;
    text-transform: capitalize;
}

.assignment__item-checkin {
    margin-bottom: .5rem;
}

.assignment__item-counsellor {
    margin-bottom: .5rem;
}

.assignment__item-description {
    font-weight: 400;
    margin-bottom: .5rem;
}

.assignment__item-email {
    margin-bottom: .5rem;
}

.assignment__item-id {
    margin-bottom: .5rem;
}

.assignment__item-number {
    color: #fd397a;
    font-size: 1rem;
    font-weight: 600;
}

.assignment__item-subheader {
    color: #2c77f4;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0;
    width: 100%;
}

.assignment__item-image {
    float: left;
    border-radius: 4px;
    margin-right: 1rem;
    height: 96px;
    width: 96px;
    -o-object-fit: cover;
    object-fit: cover;
}

.assignment__item-info {
    color: #74788d;
    font-size: 12px;
    margin-left: 112px;
}

.assignment__item-name {
    font-size: 18px;
    font-weight: 600;
    color: #48465b;
    cursor: pointer;
    /* -webkit-transition: color 0.3s ease; */
    /* transition: color 0.3s ease; */
}

.assignment__item-name:hover {
    color: #5d78ff;
    -webkit-transition: color 0.3s ease;
    transition: color 0.3s ease;
}

.assignment__item-program {
    margin-bottom: .5rem;
}

.assignment__item-waitingarea {
    /* margin-bottom: .5rem; */
}

.img__avatar {
    max-height: 250px;
    max-width: 250px;

}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.modal-body {
    font-size: 14px;
}

.modal-dialog-large {
    max-width: 992px !important;
}

.modal-title {
    font-weight: 600;
    font-size: 1rem;
    color: #48465b;
}
</style>